import { render, staticRenderFns } from "./DesignOppositionList.vue?vue&type=template&id=68eebeb2&"
import script from "./DesignOppositionList.vue?vue&type=script&lang=js&"
export * from "./DesignOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./DesignOppositionList.vue?vue&type=style&index=0&id=68eebeb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports